// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { solutionsWidgetStyles } from "@west/App/Widgets/SolutionsWidget/SolutionsWidget";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

solutionsWidgetStyles.containerWrapper = {
    css: css`
        display: flex;
        gap: 32px;
        align-items: center;

        ${xScreen("lte", "xs")} {
            align-items: start;
        }
    `,
};

solutionsWidgetStyles.icon = {
    width: "50px",
    height: "auto",
    css: css`
        min-width: 50px;
        max-height: 33px;
        ${xScreen("lte", "xs")} {
            margin-top: 20px;
        }
    `,
};

solutionsWidgetStyles.contentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

solutionsWidgetStyles.headerText = {
    css: css`
        ${TypographyStyle} {
            font-size: ${({ fieldVariant }: any) => (fieldVariant === "item" ? "24px" : "18px")};
            font-weight: bold;
            line-height: ${({ fieldVariant }: any) => (fieldVariant === "item" ? "30px" : "24px")};
            margin: 0;
        }
    `,
};

solutionsWidgetStyles.descriptionText = {
    css: css`
        ${TypographyStyle} {
            font-size: ${({ fieldVariant }: any) => (fieldVariant === "item" ? "16px" : "14px")};
            line-height: ${({ fieldVariant }: any) => (fieldVariant === "item" ? "26px" : "22px")};
            margin: 0;
        }
    `,
};

solutionsWidgetStyles.button = {
    css: css`
        margin-top: 12px;
        align-self: baseline;
    `,
};
